import classNames from 'classnames';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PiCheckCircleFill, PiCircleFill } from 'react-icons/pi';
import { ILanguage } from 'services/enums/types';
import './LanguageSelectCard.scss';

interface ILanguageSelectCardProps {
  language: ILanguage;
  isSelected?: boolean;
  onClick?: (language: ILanguage) => void;
  variant?: 'select' | 'display';
}

const LanguageSelectCard = ({
  language,
  isSelected,
  onClick,
  variant = 'select',
}: ILanguageSelectCardProps) => {
  const { t } = useTranslation();

  const description = useMemo(() => t(`language.${language.code}.description`), [language.code]);

  return (
    <div
      className={classNames(['language-select-card', variant], { isSelected })}
      onClick={() => onClick && onClick(language)}
    >
      <div className="language-select-card-header">
        <div className="language-select-card-header-name">
          {t(`language.${language.code}.name`)}
        </div>
        {!!description.length && (
          <div className="language-select-card-header-description">{description}</div>
        )}
      </div>
      {isSelected ? <PiCheckCircleFill /> : <PiCircleFill />}
    </div>
  );
};

export default LanguageSelectCard;
